import { useFormikContext } from "formik";
import { useEffect } from "react";

export const useResetOtherOptionField = (name: string, isShowOtherOptionField: boolean): void => {
  const formContext = useFormikContext();

  useEffect(() => {
    if (!isShowOtherOptionField) {
      formContext.setFieldValue(`metadata_${name}`, undefined);
      formContext.unregisterField(`metadata_${name}`);
    }
  }, [isShowOtherOptionField, name]);
};
